//Create a roster for each team.
//Even while not logged in, you can see a list of players within the chosen team.
//This here is a page that OUTPUTS that list.
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Players.css'
import '../../shared/schedule/FullScheduleCards.css'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Footer from '../../shared/components/UIElements/Footer'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import ad from '../../images/OfficeSpaceForRent.jpg'
import ad2 from '../../images/Berardinelli.JPG'

const RosterAndSchedulePage = () => {
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [rosteredPlayers, setRosteredPlayers] = useState()
	const [gamesList, setGamesList] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamId, setTeamId] = useState()
	const [photo, setPhoto] = useState()
	const leagueId = useParams().leagueId
	const session = useParams().session
	const year = useParams().year
	const teamName = useParams().teamName

	console.log('inside RosterAndSchedulePage')

	//taps into LEAGUE backend, getPlayersOnTeam.
	//Also returns wins, losses, OTlosses, and SOlosses
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/${leagueId}/${session}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))

				setRosteredPlayers(responseData.rosteredPlayers)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setPhoto(responseData.photo)
				setLeagueName(responseData.leagueName)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [session, teamName, year, leagueId])
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//Send a request to get all the games for this team to display a schedule
	//     league-controller     getTeamSchedule
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}/${session}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					console.log('whoopsie daisy')
					throw new Error(responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setGamesList(responseData.allGamesArray)

				setTeamId(responseData.teamId)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [session, teamName, year, leagueId])

	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		if (!game.date) {
			return ''
		}

		const month = months[game.date.substr(0, 2)]
		const day = game.date.substr(3, 2)

		return `${game.dayOfWeek}, ${month} ${day}`
	}

	const formatGameTime = (game) => {
		if (!game.time) {
			return ''
		}

		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
		Mobile display order:

		HOME SCORE - VISITOR SCORE
	*/

		if (game.winner === game.homeTeamId) {
			return `${Math.max(firstScore, secondScore)} - ${Math.min(
				firstScore,
				secondScore,
			)}`
		}

		if (game.winner === game.visitorTeamId) {
			return `${Math.min(firstScore, secondScore)} - ${Math.max(
				firstScore,
				secondScore,
			)}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}

	const getTeamResult = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.winner === teamId) {
			return 'W'
		}

		if (game.loser === teamId) {
			return 'L'
		}

		return 'T'
	}

	const getTeamResultClass = (game) => {
		const result = getTeamResult(game)

		if (result === 'W') {
			return 'rosterScheduleMobile__result rosterScheduleMobile__result--win'
		}

		if (result === 'L') {
			return 'rosterScheduleMobile__result rosterScheduleMobile__result--loss'
		}

		if (result === 'T') {
			return 'rosterScheduleMobile__result rosterScheduleMobile__result--tie'
		}

		return ''
	}

	const renderMobileTeam = (game, side) => {
		const isHomeTeam = side === 'home'

		const displayedTeamName = isHomeTeam
			? game.homeTeamName
			: game.visitorTeamName

		const displayedTeamId = isHomeTeam ? game.homeTeamId : game.visitorTeamId

		const displayedSeed = isHomeTeam ? game.homeTeamSeed : game.visitorTeamSeed

		const isCurrentTeam =
			displayedTeamId === teamId || displayedTeamName === teamName

		const isWinner = game.winner === displayedTeamId

		const teamContent = (
			<span className={isWinner ? 'scheduleCard__winnerPill' : ''}>
				{displayedSeed > 0 && `(${displayedSeed}) `}
				{displayedTeamName}
			</span>
		)

		if (isCurrentTeam) {
			return teamContent
		}

		return (
			<Link
				to={`/league/${leagueId}/${session}/${year}/${displayedTeamName}`}
				className='rosterScheduleMobile__opponentLink'
			>
				{teamContent}
			</Link>
		)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<StatsAndStandingsHome />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && rosteredPlayers && gamesList && (
					<React.Fragment>
						<div className='Roster rosterPageSection'>
							{/* Existing desktop/tablet roster */}
							<div className='rosterPageDesktop'>
								<h1>{teamName}</h1>

								<h2>{leagueName}</h2>

								<h4 className='h3Center'>
									{session} - {year}
								</h4>

								{photo && (
									<div className='photoDiv'>
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
											alt={`${teamName} logo`}
											className='teamPhoto'
										/>
									</div>
								)}

								<h4 className='h3Center'>
									Record: {wins} - {losses} -{' '}
									{ties + overtimeLosses + shootoutLosses}
								</h4>

								<p className='clickOn' style={{ textAlign: 'center' }}>
									(Click on a player name to see their stat history)
								</p>

								<table id='roster'>
									<thead>
										<tr>
											<th>Number</th>
											<th>Name</th>
											<th>G</th>
											<th>A</th>
											<th>Total Points</th>
										</tr>
									</thead>

									<tbody>
										{rosteredPlayers.map((player, key) => {
											return (
												<tr key={player.playerId || key}>
													<td>{player.number}</td>

													<td className='tableDataTeamName'>
														<Link
															style={{
																textDecoration: 'none',
																color: 'black',
																fontWeight: 600,
															}}
															to={`/${player.playerId}/history`}
														>
															{player.firstName} {player.lastName}{' '}
															{player.isCaptain && '(Captain)'}{' '}
															{player.isGoalie && '(Goalie)'}
														</Link>
													</td>

													<td>{player.goals}</td>
													<td>{player.assists}</td>
													<td>{player.goals + player.assists}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>

							{/* New mobile-only roster */}
							<div className='rosterPageMobile'>
								<div className='rosterPageMobile__teamCard'>
									{photo && (
										<img
											src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
											alt={`${teamName} logo`}
											className='rosterPageMobile__teamLogo'
										/>
									)}

									<div className='rosterPageMobile__teamName'>{teamName}</div>

									<div className='rosterPageMobile__divider'></div>

									<div className='rosterPageMobile__league'>{leagueName}</div>

									<div className='rosterPageMobile__season'>
										{session} - {year}
									</div>

									<div className='rosterPageMobile__record'>
										<span>Record:</span>

										<strong>
											{wins} - {losses} -{' '}
											{ties + overtimeLosses + shootoutLosses}
										</strong>
									</div>

									<div className='rosterPageMobile__instructions'>
										(Click on a player name to see their stat history)
									</div>
								</div>

								<div className='rosterPageMobile__tableWrapper'>
									<table className='rosterPageMobile__table'>
										<thead>
											<tr>
												<th>#</th>
												<th>Player</th>
												<th>G</th>
												<th>A</th>
												<th>Total</th>
											</tr>
										</thead>

										<tbody>
											{rosteredPlayers.map((player, key) => {
												return (
													<tr key={`mobile-roster-${player.playerId || key}`}>
														<td className='rosterPageMobile__number'>
															{player.number}
														</td>

														<td className='rosterPageMobile__player'>
															<Link
																to={`/${player.playerId}/history`}
																className='rosterPageMobile__playerLink'
															>
																<span>
																	{player.firstName} {player.lastName}
																</span>

																{player.isCaptain && <small>Captain</small>}

																{player.isGoalie && <small>Goalie</small>}
															</Link>
														</td>

														<td>{player.goals}</td>
														<td>{player.assists}</td>

														<td className='rosterPageMobile__points'>
															{player.goals + player.assists}
														</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							</div>
						</div>
						{/* //
					//
					//        Advertisement:
					// */}
						<div
							style={{ marginTop: '3rem', marginBottom: '3rem' }}
							className='imgDiv'
						>
							<a
								href='mailto:Jenniferfree@murrysvillesportzone.com'
								target='_blank'
							>
								<img src={ad} className='statsImg' />
							</a>
						</div>
						<div
							style={{ marginTop: '3rem', marginBottom: '3rem' }}
							className='imgDiv'
						>
							<a
								href='https://www.facebook.com/berardinellischoolofdriving'
								target='_blank'
							>
								<img src={ad2} />
							</a>
						</div>
						{/* //
					//
					//
					// */}
						{/* THIS STARTS THE TEAMS SCHEDULE */}
						{/* THIS STARTS THE TEAM SCHEDULE */}
						<div className='Roster rosterScheduleSection'>
							<div className='rosterScheduleDesktop'>
								<h1>Schedule:</h1>

								<p className='clickOn' style={{ textAlign: 'center' }}>
									(Click on the final score of a game to see a Game Summary)
								</p>

								<p className='clickOn' style={{ textAlign: 'center' }}>
									(Click on a Home or Visitor team to go to their roster and
									schedule page)
								</p>

								<table id='teamSchedule'>
									<thead>
										<tr>
											<th>Date/Time</th>
											<th>Opponent</th>
											<th>Score</th>
										</tr>
									</thead>

									<tbody>
										{gamesList.map((game, key) => {
											return (
												<tr key={game._id || key}>
													<td>
														{formatGameDate(game)}
														<br />
														{formatGameTime(game)}
														<br />
														{game.venueName}
													</td>

													{game.homeTeamName === teamName && (
														<td className='tableDataTeamName'>
															<Link
																style={{
																	textDecoration: 'none',
																	color: 'black',
																	fontWeight: 600,
																}}
																to={`/league/${leagueId}/${session}/${year}/${game.visitorTeamName}`}
															>
																{game.visitorTeamName}
															</Link>
														</td>
													)}

													{game.visitorTeamName === teamName && (
														<td className='tableDataTeamName'>
															<Link
																style={{
																	textDecoration: 'none',
																	color: 'black',
																	fontWeight: 600,
																}}
																to={`/league/${leagueId}/${session}/${year}/${game.homeTeamName}`}
															>
																@ {game.homeTeamName}
															</Link>
														</td>
													)}

													{!game.score && <td></td>}

													{game.score && !game.winner && !game.loser && (
														<td
															style={{
																color: 'black',
																fontWeight: 'bold',
															}}
														>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'black',
																}}
																to={`/gameSummary/${game._id}`}
															>
																TIED {game.score}
															</Link>
														</td>
													)}

													{game.loser === teamId && (
														<td
															style={{
																color: 'red',
																fontWeight: 'bold',
															}}
														>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'red',
																}}
																to={`/gameSummary/${game._id}`}
															>
																LOST {game.score}
																{game.status === 'Overtime' && ' (OT)'}
																{game.status === 'Shootout' && ' (SO)'}
															</Link>
														</td>
													)}

													{game.winner === teamId && (
														<td
															style={{
																color: 'green',
																fontWeight: 'bold',
															}}
														>
															<Link
																style={{
																	textDecoration: 'none',
																	fontWeight: 600,
																	color: 'green',
																}}
																to={`/gameSummary/${game._id}`}
															>
																WON {game.score}
																{game.status === 'Overtime' && ' (OT)'}
																{game.status === 'Shootout' && ' (SO)'}
															</Link>
														</td>
													)}
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>

							<div className='rosterScheduleMobile'>
								<div className='rosterScheduleMobile__heading'>
									Team Schedule
								</div>

								<div className='rosterScheduleMobile__instructions'>
									Click a final score to see the Game Summary. Click the
									opposing team to visit its roster and schedule.
								</div>

								<div className='scheduleCardsMobile rosterScheduleCardsMobile'>
									{gamesList.map((game, key) => {
										const isSpecialGame =
											game.playoff || game.championship || game.description

										return (
											<div
												className={`scheduleCard ${
													isSpecialGame ? 'scheduleCardSpecial' : ''
												}`}
												key={`roster-schedule-mobile-${game._id || key}`}
											>
												<div className='scheduleCard__header'>
													<div>{formatGameDate(game)}</div>

													<div className='scheduleCard__league'>
														{game.championship
															? 'CHAMPIONSHIP'
															: game.playoff
																? 'PLAYOFF'
																: game.leagueName || leagueName || 'Game'}
													</div>

													<div>{formatGameTime(game)}</div>
												</div>

												{game.homeTeamName && game.visitorTeamName ? (
													<>
														<div className='scheduleCard__body'>
															<div className='scheduleCard__team'>
																{renderMobileTeam(game, 'home')}
															</div>

															<div className='scheduleCard__scoreBox'>
																{getTeamResult(game) && (
																	<div className={getTeamResultClass(game)}>
																		{getTeamResult(game)}
																	</div>
																)}

																{game.score ? (
																	<Link
																		to={`/gameSummary/${game._id}`}
																		className='scheduleCard__score'
																	>
																		{getDisplayScore(game)}
																	</Link>
																) : (
																	<div className='scheduleCard__score'>TBP</div>
																)}

																{game.score && (
																	<div className='scheduleCard__status'>
																		{getGameStatus(game)}
																	</div>
																)}
															</div>

															<div className='scheduleCard__team'>
																{renderMobileTeam(game, 'visitor')}
															</div>
														</div>

														<div className='scheduleCard__venue'>
															📍 {game.venueName}
														</div>

														{game.description && (
															<div className='scheduleCard__description'>
																{game.description}
															</div>
														)}

														{game.championship && (
															<div className='scheduleCard__description'>
																CHAMPIONSHIP GAME
															</div>
														)}

														{game.playoff && !game.championship && (
															<div className='scheduleCard__description'>
																PLAYOFF GAME
															</div>
														)}
													</>
												) : (
													<>
														<div className='scheduleCard__event'>
															{game.eventName ||
																game.description ||
																'Scheduled Event'}
														</div>

														<div className='scheduleCard__venue'>
															📍 {game.venueName}
														</div>
													</>
												)}
											</div>
										)
									})}
								</div>
							</div>
						</div>
						<Footer />
					</React.Fragment>
				)}
			</React.Fragment>
		</div>
	)
}

export default RosterAndSchedulePage
